import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useAppState } from '../../../state';
import UserAvatar from './UserAvatar/UserAvatar';

const useStyles = makeStyles({
  userContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: '1em',
    display: 'flex',
    alignItems: 'center',
  },
  userButton: {
    color: 'white',
  },
});

const UserMenu: React.FC = () => {
  const classes = useStyles();
  const { user } = useAppState();

  if (user?.isExpert) {
    return (
      <div className={classes.userContainer}>
        <UserAvatar user={user} />
      </div>
    );
  }

  return null;
};

export default UserMenu;
